import { RemoteHandleSummaryReportByGroup } from 'data/usecases';
import { HandleSummaryReportByGroup } from 'domain/usecases';
import { makeApiUrlSummaryReportByGroup } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeSummaryReportByGroup = (): HandleSummaryReportByGroup =>
  new RemoteHandleSummaryReportByGroup(
    makeApiUrlSummaryReportByGroup(),
    makeAxiosHttpClient(),
  );
